import { AUTH_ROLES, POLICY_PERMISSIONS } from './auth.constants';
import { POLICY_INFO_PAGE } from './components.constants';

export const POLICY_ROLES = Object.values(POLICY_PERMISSIONS);

export const PERMISSIONS = {
  APP: {
    VIEW_APP: [AUTH_ROLES.TRIPX_READ]
  },
  BOOKING: {
    BOOK_QUOTE: [AUTH_ROLES.POLICY_BOOKING, AUTH_ROLES.GRAPH_API, AUTH_ROLES.POLICY_NOTIFICATION],
    VIEW_PLANS: [],
    ANSWER_MQ: [AUTH_ROLES.POLICY_BOOKING, AUTH_ROLES.GRAPH_API],
    ANSWER_NAQC: [AUTH_ROLES.POLICY_BOOKING, AUTH_ROLES.GRAPH_API],
    PAYMENT: [AUTH_ROLES.POLICY_BOOKING, AUTH_ROLES.POLICY_EDIT]
  },
  POLICY_MAINTENANCE: {
    VIEW_ALL_POLICIES: [AUTH_ROLES.POLICY_READ],
    VIEW_ASSOCIATED_POLICY: [AUTH_ROLES.POLICY_READ],
    EDIT_POLICY: [AUTH_ROLES.POLICY_EDIT],
    EDIT_DEPARTURE_CITY: [AUTH_ROLES.POLICY_EDIT],
    ADD_TRAVEL_DESTINATION: [AUTH_ROLES.POLICY_EDIT],
    ADD_REMOVE_RIDER: [AUTH_ROLES.POLICY_EDIT],
    SEND_CONFIRMATION: [AUTH_ROLES.POLICY_READ, AUTH_ROLES.POLICY_NOTIFICATION],
    REFUND_POLICY: [AUTH_ROLES.POLICY_EDIT],
    VIEW_FINANCIAL_TRANSACTIONS: [AUTH_ROLES.POLICY_READ],
    VIEW_POLICY_NOTES: [AUTH_ROLES.POLICY_READ, AUTH_ROLES.POLICY_NOTE_READ],
    ADD_NOTE: [AUTH_ROLES.POLICY_EDIT, AUTH_ROLES.POLICY_NOTE_EDIT],
    FILTER_NOTES: [AUTH_ROLES.POLICY_READ, AUTH_ROLES.POLICY_NOTE_READ],
    VIEW_DELIVERY: [AUTH_ROLES.POLICY_READ],
    DOWNLOAD_CONFIRMATION: [],
    REINSTATE_POLICY: [AUTH_ROLES.POLICY_ADMIN]
  },
  AGENT_ADMINISTRATION: {
    VIEW_ALL_AGENTS: [AUTH_ROLES.AGENT_ADMINISTRATION_READ, AUTH_ROLES.TRIPX_READ],
    ADD_AGENT: [AUTH_ROLES.AGENT_ADMINISTRATION_READ, AUTH_ROLES.AGENT_ADMINISTRATION_CREATE, AUTH_ROLES.TRIPX_READ],
    FILTER_AGENTS: [],
    EDIT_AGENT: [AUTH_ROLES.AGENT_ADMINISTRATION_READ, AUTH_ROLES.AGENT_ADMINISTRATION_UPDATE, AUTH_ROLES.TRIPX_READ],
    DELETE_AGENT: [AUTH_ROLES.AGENT_ADMINISTRATION_READ, AUTH_ROLES.AGENT_ADMINISTRATION_DELETE, AUTH_ROLES.TRIPX_READ]
  },
  ADVISOR_ADMINISTRATION: {
    VIEW_ALL_ADVISORS: [AUTH_ROLES.PROFILE_ADVISOR_READ, AUTH_ROLES.TRIPX_READ],
    ADD_ADVISOR: [AUTH_ROLES.PROFILE_ADVISOR_READ, AUTH_ROLES.PROFILE_ADVISOR_CREATE, AUTH_ROLES.TRIPX_READ]
  },
  REPORTS: {
    VIEW_REPORTS: [AUTH_ROLES.REPORT_READ]
  },
  ADVISOR_REPORTS: {
    VIEW_ADVISOR_REPORTS: [AUTH_ROLES.ADVISOR_REPORT]
  },
  AGENCY_DETAILS: {
    VIEW_AGENCY_TAB: [AUTH_ROLES.AGENT_ORGANIZATION_READ],
    EDIT_AGENCY_TAB: [AUTH_ROLES.AGENT_ORGANIZATION_EDIT],
    CREATE_AGENCY: [AUTH_ROLES.AGENCY_CREATE]
  },
  TOOLS: {
    VIEW_RATES: [AUTH_ROLES.RATES_READ],
    EDIT_RATES: [AUTH_ROLES.RATES_EDIT]
  },
  DESTINATION_MULTIPLIER: {
    VIEW_DESTINATION_MULTIPLIER: [AUTH_ROLES.DESTINATION_MULTIPLIER_READ],
    EDIT_DESTINATION_MULTIPLIER: [AUTH_ROLES.DESTINATION_MULTIPLIER_EDIT]
  },
  CONFIGURATION: {
    VIEW_CONFIGURATION: [
      AUTH_ROLES.TRIPX_CONFIG_EDIT,
      AUTH_ROLES.TRIPX_READ,
      AUTH_ROLES.TRIPX_EDIT,
      AUTH_ROLES.TRIPX_DELETE
    ]
  },
  LICENSING: {
    VIEW_LICENSE: [AUTH_ROLES.LICENSE_READ, AUTH_ROLES.AGENT_ADMINISTRATION_READ],
    EDIT_LICENSE: [AUTH_ROLES.LICENSE_EDIT, AUTH_ROLES.AGENT_ADMINISTRATION_UPDATE],
    ADD_LICENSING: [AUTH_ROLES.LICENSE_CREATE, AUTH_ROLES.AGENT_ADMINISTRATION_UPDATE]
  },
  REMERCH: {
    REMERCH_CREATE: [AUTH_ROLES.REMERCH_CREATE]
  }
};

export const MENU_PERMISSIONS = {
  travelInsurance: PERMISSIONS.BOOKING.BOOK_QUOTE,
  maintenance: PERMISSIONS.POLICY_MAINTENANCE.VIEW_ALL_POLICIES,
  myReports: PERMISSIONS.REPORTS.VIEW_REPORTS,
  'users-internal': PERMISSIONS.AGENT_ADMINISTRATION.VIEW_ALL_AGENTS,
  advisorAdmin: PERMISSIONS.ADVISOR_ADMINISTRATION.VIEW_ALL_ADVISORS,
  destinationMultiplierSub: PERMISSIONS.DESTINATION_MULTIPLIER.VIEW_DESTINATION_MULTIPLIER
};

export const POLICY_TABS_PERMISSIONS = {
  [POLICY_INFO_PAGE.ASSOCIATED_POL]: PERMISSIONS.POLICY_MAINTENANCE.VIEW_ASSOCIATED_POLICY,
  [POLICY_INFO_PAGE.FINANCIAL_TRANS]: PERMISSIONS.POLICY_MAINTENANCE.VIEW_FINANCIAL_TRANSACTIONS,
  [POLICY_INFO_PAGE.POL_NOTE]: PERMISSIONS.POLICY_MAINTENANCE.VIEW_POLICY_NOTES,
  [POLICY_INFO_PAGE.POL_DLVR]: PERMISSIONS.POLICY_MAINTENANCE.VIEW_DELIVERY
};
